import React, { useEffect, useState } from 'react';

// "Page [ 38 ] of 107": type a page number and press Enter to jump there. Accepts "38" or "38/107";
// out-of-range numbers clamp to 1..totalPages. Escape or leaving the box puts the current page back.
const PageJumpInput = ({ currentPage, totalPages, onChange, disabled }) => {
    const last = Math.max(totalPages, 1);
    const [text, setText] = useState(String(currentPage));

    useEffect(() => { setText(String(currentPage)); }, [currentPage]);

    const commit = () => {
        const n = parseInt(String(text).trim().split('/')[0], 10);
        if (!Number.isFinite(n)) { setText(String(currentPage)); return; }
        const page = Math.min(Math.max(n, 1), last);
        setText(String(page));
        if (page !== currentPage) onChange(page);
    };

    return (
        <span className="pagination-current">
            Page{' '}
            <input
                className="pagination-jump-input"
                type="text"
                inputMode="numeric"
                aria-label={`Page number, 1 to ${last}`}
                title="Type a page number and press Enter"
                value={text}
                disabled={disabled}
                onChange={(e) => setText(e.target.value)}
                onFocus={(e) => e.target.select()}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') { e.preventDefault(); commit(); }
                    else if (e.key === 'Escape') { setText(String(currentPage)); e.target.blur(); }
                }}
                onBlur={() => setText(String(currentPage))}
                style={{ width: `${Math.max(String(last).length, 2) + 2}ch` }}
            />{' '}
            of {last}
        </span>
    );
};

export default PageJumpInput;
